import { Clock, RefreshCw } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

interface UserTimezoneDisplayProps {
  timezoneDisplay: string | null;
  onRefresh?: () => void;
}

const UserTimezoneDisplay = ({
  timezoneDisplay,
  onRefresh
}: UserTimezoneDisplayProps) => {
  if (!timezoneDisplay) {
    return null;
  }

  return (
    <Card className="mt-3 border-amber-200 bg-amber-50">
      <CardContent className="p-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <Clock className="h-4 w-4 text-amber-600" />
            <div>
              <p className="text-sm font-semibold text-amber-800">
                Your Timezone
              </p>
              <div className="text-xs text-amber-700">
                {timezoneDisplay}
              </div>
            </div>
          </div>
          {onRefresh && (
            <Button
              variant="ghost"
              size="sm"
              onClick={onRefresh}
              className="h-8 px-2 text-amber-700 hover:text-amber-800 hover:bg-amber-100"
            >
              <RefreshCw className="h-3 w-3" />
            </Button>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default UserTimezoneDisplay;